import { render, staticRenderFns } from "./messageDetails.vue?vue&type=template&id=2bccb10d&"
import script from "./messageDetails.vue?vue&type=script&lang=js&"
export * from "./messageDetails.vue?vue&type=script&lang=js&"
import style0 from "./messageDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports